import React from "react";
import * as styles from "./detailed-status-row.module.scss";
import { VelavuDevice } from "velavu-js-api";
import { getDeviceStatus } from "../helper/status-helper";
import StatusIndicator from "./status-indicator";
import { mapConnectionStatus } from "../helper/language-helper";
import { lastUpdated } from "../helper/time-helper";

export interface DetailedStatusRowProps {
	device: VelavuDevice;
}

/**
 * A component that shows the status of a device,
 * along with the last seen time if the device is offline.
 */
export default function DetailedStatusRow(props: DetailedStatusRowProps) {
	const status = getDeviceStatus(props.device);

	if (props.device.online === false && props.device.heartbeat !== undefined) {
		//Show heartbeat
		return (
			<div className={styles.verticalContainer}>
				<div className={styles.horizontalContainer}>
					<StatusIndicator status={status} />
					<span>{mapConnectionStatus(status)}</span>
				</div>

				<span className={styles.statusText}>
					{`Last seen: ${lastUpdated(props.device.heartbeat)}`}
				</span>
			</div>
		);
	} else {
		return (
			<div className={styles.horizontalContainer}>
				<StatusIndicator status={status} />
				<span>{mapConnectionStatus(status)}</span>
			</div>
		);
	}
}
